import { Component } from '@angular/core';
import { AppNotification, NotificationActionLink } from '../../../models/notification.model';
import { NotificationsService } from '../../../services/notifications.service';

@Component({
  selector: 'app-important-notification-modal',
  templateUrl: './important-notification-modal.component.html',
  styleUrls: ['./important-notification-modal.component.css']
})
export class ImportantNotificationModalComponent {
  readonly notification = this.notificationsService.activeImportantNotification;

  constructor(private readonly notificationsService: NotificationsService) {}

  async dismiss(notification: AppNotification): Promise<void> {
    await this.notificationsService.dismissImportantNotification(notification);
  }

  trackByStep(index: number): number {
    return index;
  }

  trackByLink(index: number, link: NotificationActionLink): string {
    return `${link.route}-${link.label}-${index}`;
  }
}
